import { line, curveMonotoneX } from 'd3-shape';
import { scaleLinear } from 'd3-scale';

export function sparkPath(data: number[], width = 80, height = 24): string {
  if (data.length === 0) return '';
  const min = Math.min(...data);
  const max = Math.max(...data);
  const x = scaleLinear().domain([0, data.length - 1]).range([0, width]);
  const y = scaleLinear().domain([min, max]).range([height - 1, 1]);
  const ln = line<number>()
    .x((_, i) => x(i))
    .y((d) => y(d))
    .curve(curveMonotoneX);
  return ln(data) ?? '';
}
